<script setup>
import { useRoute } from 'vue-router'
import { computed, ref, onMounted } from 'vue'
import logoSvg from '../../logo.svg'
import { getCurrentUser, isUserLoggedIn } from '../services/drupal'

const route = useRoute()

// 检查是否在听写页面（包括英文和中文模式）
const isDictationActive = computed(() => {
  return route.path === '/dictation' || route.path === '/dictation-chinese'
})

// 用户信息
const currentUser = ref(null)
const isLoggedIn = ref(false)

// 获取用户信息
onMounted(() => {
  isLoggedIn.value = isUserLoggedIn()
  if (isLoggedIn.value) {
    currentUser.value = getCurrentUser()
  }
})

// 登出函数
const handleLogout = () => {
  window.location.href = '/user/logout'
}
</script>

<template>
  <nav class="layout-header">
    <div class="container-header">
      <div class="logo">
        <a href="/"><img :src="logoSvg" alt="BILL爱背单词" class="w-50 h-auto" /></a>
      </div>
      <div class="tools">
        <!-- 已登录状态 -->
        <template v-if="isLoggedIn">
          <!--
          <a
            :href="`/user/${currentUser?.uid || ''}`"
            class="menu-item flex items-center gap-2">
            <img
              v-if="currentUser?.picture"
              :src="currentUser.picture"
              :alt="currentUser.name"
              class="w-8 h-8 rounded-full object-cover" />
            <span>{{ currentUser?.name || '用户' }}</span>
          </a> 
          -->
          <button
            @click="handleLogout"
            class="menu-item cursor-pointer"
            type="button">
            登出
          </button>
        </template>

        <!-- 未登录状态 -->
        <template v-else>
          <a href="/user/login" class="menu-item">
            登录
          </a>
        </template>

        <!--
          <router-link
            to="/question-bank-editor"
            class="menu-item"
            active-class="menu-item menu-item-active">
            加题
          </router-link>
        -->
      </div>
      <div class="main-menu">
        <ul class="menu">
          <li>
            <router-link
              to="/words"
              active-class="is-active"
              :class="[$route.path.startsWith('/words') ? 'is-active' : '']">
              <i class="wenicon icon-credit_card text-4xl"></i>
              单词卡
            </router-link>
          </li><li>
            <router-link
              to="/phrases"
              class=""
              active-class="is-active"
              :class="[$route.path.startsWith('/phrases') ? 'is-active' : '']">
              <i class="wenicon icon-grid text-4xl"></i>
              词组
            </router-link>
          </li><li>
            <router-link
              to="/irregular"
              active-class="is-active"
              :class="[$route.path.startsWith('/irregular') ? 'is-active' : '']">
              <i class="wenicon icon-filter_alt text-4xl"></i>
              不规则动词
            </router-link>
          </li><li>
            <router-link
              to="/dictation"
              active-class="is-active"
              :class="[$route.path.startsWith('/dictation') ? 'is-active' : '']">
              <i class="wenicon icon-a-cuotiben-cuotifuxi2 text-4xl"></i>
              单词默写
            </router-link>
          </li>
            <router-link
            to="/quiz"
            class="menu-item"
            :class="[$route.path.startsWith('/quiz') ? 'is-active' : '']">
            <i class="wenicon icon-calendar_month text-4xl"></i>
            刷题
          </router-link>
          <!-- <router-link
            to="/wrong-words"
            class="menu-item"
            active-class="menu-item menu-item-active">
            错题本
          </router-link> -->
        </ul>
      </div>
    </div>
  </nav>


</template>
